import { render, staticRenderFns } from "./CalendarioAcademico.vue?vue&type=template&id=6405af4c"
import script from "./CalendarioAcademico.vue?vue&type=script&lang=js"
export * from "./CalendarioAcademico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports